import fetch from "./sessionFetch";
import { authHeaders, baseUrl, handleResponse } from './apiUtils';

async function getOverview(studentId, { schoolYearStart, section = 'current', cursor, signal }) {
  const query = new URLSearchParams({ schoolYearStart: String(schoolYearStart), section, limit: '25' });
  if (cursor) query.set('cursor', cursor);
  const response = await fetch(`${baseUrl}students/${encodeURIComponent(studentId)}/classes-overview?${query}`, {
    headers: authHeaders(), signal,
  });
  try {
    return await handleResponse(response);
  } catch (error) {
    // Preserve the status even for generic shared-handler errors such as 401/400.
    error.code = response.status;
    throw error;
  }
}

export default { getOverview };
